import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// filepath: /D:/xamp8.2/htdocs/chaseit1416/resources/js/Components/Post.tsx
import React, { useEffect, useState } from "react";
import icons from "../utils/Icons";
import ImageModal from "./modals/ImageModal";
import axios from "axios";
import { useSelector } from "react-redux";
import IconButton from "@mui/material/IconButton";
import { Menu, MenuItem } from "@mui/material";
import MoreHoriz from "@mui/icons-material/MoreHoriz";
import CloudinaryVideoPlayer from "./cloudinary/CloudinaryVideoPlayer";
export var Post = function (_a) {
    var _b;
    var post = _a.post, updateLikes = _a.updateLikes, openLikesModal = _a.openLikesModal, openCommentsModal = _a.openCommentsModal, deletePost = _a.deletePost;
    var _c = useState(null), anchorEl = _c[0], setAnchorEl = _c[1];
    var handleMenuOpen = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleMenuClose = function () {
        setAnchorEl(null);
    };
    var _d = useState(false), showImageModal = _d[0], setShowImageModal = _d[1];
    var _e = useState(false), postLiked = _e[0], setPostLiked = _e[1];
    var _f = useState(""), modalImage = _f[0], setModalImage = _f[1];
    var userId = useSelector(function (state) { return state.user.userId; });
    var openImageModal = function (image) {
        setShowImageModal(true);
        setModalImage(image);
    };
    var closeImageModal = function () {
        setShowImageModal(false);
    };
    var getUserImage = function () {
        var _a;
        if (post.users && ((_a = post === null || post === void 0 ? void 0 : post.users) === null || _a === void 0 ? void 0 : _a.public_id)) {
            return "https://res.cloudinary.com/chaseit1416/image/upload/c_thumb,g_face,h_400,w_400/c_scale,w_50/".concat(post.users.public_id);
        }
    };
    var convertImageSrvToScaled = function (src) {
        var vm = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
        var width = null;
        var img = src.split("/");
        var imgName = img[img.length - 1];
        img.pop();
        img.pop();
        if (vm < 400) {
            width = 400;
        }
        else if (vm > 400 && vm < 800) {
            width = 800;
        }
        if (width == null) {
            return src;
        }
        var addition = ["f_auto", "q_auto", "c_scale,w_".concat(width)];
        var url = img.join("/");
        return "".concat(url, "/").concat(addition.join("/"), "/").concat(imgName);
    };
    var timeSince = function (createdAt) {
        var now = new Date();
        var createdAtDate = new Date(createdAt);
        var diffMs = now.getTime() - createdAtDate.getTime();
        var diffSec = Math.floor(diffMs / 1000);
        if (diffSec < 60) {
            return "".concat(diffSec, " ").concat(diffSec === 1 ? "sec" : "secs", " ago");
        }
        else if (diffSec < 3600) {
            var mins = Math.floor(diffSec / 60);
            return "".concat(mins, " ").concat(mins === 1 ? "min" : "mins", " ago");
        }
        else if (diffSec < 86400) {
            var hours = Math.floor(diffSec / 3600);
            return "".concat(hours, "h ago");
        }
        else if (diffSec < 2592000) {
            // 30 days
            var days = Math.floor(diffSec / 86400);
            return "".concat(days, " ").concat(days === 1 ? "day" : "days", " ago");
        }
        else if (diffSec < 31536000) {
            // 365 days
            var months = Math.floor(diffSec / 2592000); // Approximate 30 days per month
            return "".concat(months, " ").concat(months === 1 ? "month" : "months", " ago");
        }
        else {
            var years = Math.floor(diffSec / 31536000);
            return "".concat(years, " ").concat(years === 1 ? "year" : "years", " ago");
        }
    };
    var postLikeHandle = function (likesArray) {
        var formData = new FormData();
        // formData.append("flag", postLiked);
        // formData.append("post_id", post.id);
        // formData.append("user_id", userId);
        axios
            .post("/likes", {
            flag: postLiked,
            post_id: post.id,
            user_id: userId,
        })
            .then(function (response) {
            updateLikes(response.data.post);
        })
            .catch(function (error) {
            console.error("File delete failed:", error);
        })
            .finally(function () {
            // setUploading(false);
        });
        // if (likesArray.length === 0) {
        //     return false;
        // } else {
        //     let flag = false;
        //     for (var i = 0; i < likesArray.length; i++) {
        //         if (likesArray[i].user_id === this.user_id) {
        //             flag = true;
        //         }
        //     }
        //     return flag;
        // }
    };
    useEffect(function () {
        var likesArray = post.likes;
        var flag = false;
        if (likesArray.length > 0) {
            for (var i = 0; i < likesArray.length; i++) {
                if (likesArray[i].user_id === userId) {
                    flag = true;
                }
            }
        }
        setPostLiked(flag);
    }, [post.likes]);
    var handleDeletePost = function () {
        handleMenuClose();
        deletePost(post.id);
    };
    return (_jsxs("div", { className: "flex mt-5 items-start max-w-full w-[357px] md:w-[75%] md:mx-auto", children: [showImageModal && (_jsx(ImageModal, { closeModal: closeImageModal, imagePath: modalImage })), _jsx("img", { loading: "lazy", src: getUserImage(), alt: "".concat(post.users.name, "'s avatar"), className: "object-contain shrink-0 w-10 mr-3 rounded-3xl aspect-square" }), _jsxs("div", { className: "flex flex-col flex-1 shrink basis-0 ", children: [_jsxs("div", { className: "flex justify-between items-center w-full whitespace-nowrap", children: [_jsxs("div", { className: "flex gap-1.5 items-center self-stretch my-auto", children: [_jsxs("div", { className: "flex gap-2 items-center self-stretch my-auto", children: [_jsx("div", { className: "self-stretch my-auto text-base font-medium leading-none text-slate-900", children: post.users.name }), _jsxs("div", { className: "self-stretch my-auto lowercase text-base leading-none text-neutral-400", children: ["@", post.users.name] })] }), _jsx("div", { className: "self-stretch my-auto w-1 text-base font-semibold text-neutral-400", children: "\u00B7" }), _jsx("div", { className: "self-stretch my-auto text-base leading-none text-neutral-400", children: timeSince(post.created_at) })] }), ((_b = post === null || post === void 0 ? void 0 : post.users) === null || _b === void 0 ? void 0 : _b.id) === userId && (_jsxs(_Fragment, { children: [_jsx(IconButton, { onClick: handleMenuOpen, children: _jsx(MoreHoriz, {}) }), _jsx(Menu, { anchorEl: anchorEl, open: Boolean(anchorEl), onClose: handleMenuClose, children: _jsx(MenuItem, { onClick: handleDeletePost, children: "Delete" }) })] }))] }), _jsxs("div", { className: "flex flex-col mt-3 w-full", children: [_jsx("div", { className: "text-base leading-none text-zinc-600", children: post.caption }), post.image_id && (_jsx("img", { onClick: function () { return openImageModal(post.image.path); }, loading: "lazy", src: convertImageSrvToScaled(post.image.path), alt: "", className: "mt-2.5 w-full rounded-xl" })), post.video_id && (_jsx(CloudinaryVideoPlayer, { publicId: post.video.public_id })), _jsxs("div", { className: "flex flex-col self-start mt-2.5", children: [_jsxs("div", { className: "flex gap-1.5 items-center self-start", children: [_jsx("button", { onClick: function () { return postLikeHandle(post.likes); }, "aria-label": "Like post", className: "flex overflow-hidden flex-col justify-center self-stretch px-1 py-1 my-auto w-6", children: _jsx("img", { loading: "lazy", 
                                                    // src={checkLike()}
                                                    src: postLiked ? icons.redHeart : icons.heart, alt: "", className: "object-contain aspect-[1.12] w-[18px]" }) }), _jsx("button", { onClick: function () { return openCommentsModal(post); }, "aria-label": "Comment on post", className: "flex overflow-hidden flex-col justify-center self-stretch p-1 my-auto w-6", children: _jsx("img", { loading: "lazy", src: "https://cdn.builder.io/api/v1/image/assets/8fcf339d38324041a609e3cdaa6dded0/976f99e2a5768d72e81233b480260ab92d634e83f51c5b091caeeaa3003da87e?apiKey=8fcf339d38324041a609e3cdaa6dded0&", alt: "", className: "object-contain aspect-square w-[18px]" }) })] }), _jsxs("div", { className: "flex gap-1 items-start mt-1.5 text-sm leading-none text-neutral-400", children: [_jsxs("div", { className: "pr-2", onClick: function () { return openLikesModal(post); }, children: [post.likes_count, " likes"] }), _jsx("div", { className: "w-1 font-semibold", children: "\u00B7" }), _jsxs("div", { onClick: function () { return openCommentsModal(post); }, children: [post.comments_count, " comments"] })] })] })] })] })] }));
};
